"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icon_1 = __importDefault(require("../../icon"));
function DescListItem(props) {
    var txt = props.txt;
    return (react_1.default.createElement("div", { className: "desc-swap" },
        react_1.default.createElement(icon_1.default, { name: "check", size: 24, color: "#006EFF", className: "desc-icon" }),
        react_1.default.createElement("div", { className: "desc" }, txt)));
}
exports.default = DescListItem;
//# sourceMappingURL=DescListItem.js.map